import React from "react";
import { bool, number, object, string } from "prop-types";
import get from "lodash/get";

import { showSpecificNumOfWord } from "../../utils/utils";

import "./contributor.m.css";

const Contributor = ({
  name,
  className = "",
  contributorType = 1,
  role = "",
  authorObj = {},
  showBio = false,
  authorLocation = "",
  seperator,
  dataAuthor = false,
  scrollIndex = 0,
  authorLocationForStory,
}) => {
  const publicAuthorRole = authorObj["contributor-role"]?.name === "Public Author" ? "yes" : "";

  const authorBio = get(authorObj, ["bio"], "");

  const authorTarget = () => {
    if (!dataAuthor) return {};
    const author = name.match("লেখা") ? authorLocationForStory : name;
    return { [`data-author-${scrollIndex}`]: author?.trim() };
  };

  return (
    <div
      styleName={` base contributor-type-${contributorType}`}
      className={`${className} contributor-type-${contributorType}`}
    >
      <span {...authorTarget()} styleName="contributor-name" className="contributor-name">
        {name?.trim()}
      </span>
      {seperator || ""}
      {authorLocation && <span styleName="author-location">{authorLocation}</span>}
      {showBio && authorBio && publicAuthorRole === "yes" && (
        <span styleName="author-bio" className="author-bio">
          {showSpecificNumOfWord(authorBio)}
        </span>
      )}
      {role && <span className="contributor-role">{role}</span>}
    </div>
  );
};

Contributor.propTypes = {
  name: string,
  className: string,
  contributorType: number,
  role: string,
  authorObj: object,
  showBio: bool,
  authorLocation: string,
  seperator: string,
  dataAuthor: bool,
  scrollIndex: number,
  authorLocationForStory: string,
};

export default Contributor;
